import React, { useState, useMemo } from 'react';
import { Segment } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import GamesTable from './Table';
import Visualis from './Visualis';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import { useIntl } from 'umi';

const EditionsShareCard = (props: any) => {
  const {
    chartType,
    setChartType,
    fixedTableData,
    tableData = [],
    lineData,
    cardStatus,
    tableTotal,
    dateType,
    columnsList,
    tableLoading,
    onTableSortChage,
    onTablePagingChange,
    entityType,
    setChartLoading,
    chartLoading,
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法
  const { isLoading, isError, isNoData } = cardStatus || {};

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_games_share` })}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-editionsshare-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_games_share` })}
        activeTab={'line'}
        disableChartType={['bar', 'pie']}
      >
        <div className="editionsshare-card-line">
          <Visualis
            chartType={chartType}
            dateType={dateType}
            imageType={entityType}
            lineData={lineData}
            isNodata={isNoData}
            chartLoading={chartLoading}
            setChartLoading={setChartLoading}
            topChartsType={'gamesOwned-revenueDownload-game'}
          />
        </div>
        {/* 表格头部加table-header-normal没有排序样式  table-header是排序样式*/}

        <GamesTable
          entityType={entityType}
          tableTotal={tableTotal}
          tableData={tableData}
          dateType={dateType}
          columnsList={columnsList}
          tableLoading={tableLoading}
          onTableSortChage={onTableSortChage}
          onTablePagingChange={onTablePagingChange}
        />
      </CardSlotV2>
    </div>
  );
};

export default EditionsShareCard;
